import GenericUtils from "../../utils/GenericUtils";
import SelectOption from "../SelectOption";

export enum TipoCartaoEnum {
    HoraLetiva = 1,
    HoraNaoLetiva,
    HoraNaoLetivaFlutuante,
    Intrajornada,
    Esporadica,
    Antecipacao,
    Substituicao,
    Reposicao,
    AtividadesAvulsas,
    HoraExtraTela,
    HoraExtraImportacao,
}

export const TipoCartaoEnumLabel = new Map<TipoCartaoEnum, string>([
    [TipoCartaoEnum.HoraLetiva, "Hora Letiva"],
    [TipoCartaoEnum.HoraNaoLetiva, "Hora Não Letiva"],
    [
        TipoCartaoEnum.HoraNaoLetivaFlutuante,
        "Hora Não Letiva - Matriz Curricular",
    ],
    [TipoCartaoEnum.Intrajornada, "Intrajornada"],
    [TipoCartaoEnum.Esporadica, "Esporádica"],
    [TipoCartaoEnum.Antecipacao, "Antecipação"],
    [TipoCartaoEnum.Substituicao, "Substituição"],
    [TipoCartaoEnum.Reposicao, "Reposição"],
    [TipoCartaoEnum.AtividadesAvulsas, "Atividade Avulsa"],
    [TipoCartaoEnum.HoraExtraTela, "Hora Letiva RE"],
    [TipoCartaoEnum.HoraExtraImportacao, "Hora Letiva RE"],
]);

export const getOptionsTipoCartaoEnum = () => {
    const enumList = Array.from(TipoCartaoEnumLabel).map((item: any) => {
        return GenericUtils.impl<SelectOption>({
            value: String(item.at(0)),
            label: item.at(1),
        });
    });

    return enumList?.sort((a, b) => a.label.localeCompare(b.label));
};

export const getLabelTipoCartaoEnum = (value: TipoCartaoEnum) => {
    return TipoCartaoEnumLabel.get(value);
};

export const getValueTipoCartaoEnum = (label: string) => {
    const value = getOptionsTipoCartaoEnum()?.find(
        (item) => item?.label?.toLowerCase() === label?.toLowerCase()
    )?.value;
    return value ? Number(value) : undefined;
};

export const isCartaoEspecial = (cartaoTipoId: number) => {
    return (
        TipoCartaoEnum.Antecipacao === cartaoTipoId ||
        TipoCartaoEnum.Substituicao === cartaoTipoId ||
        TipoCartaoEnum.Reposicao === cartaoTipoId ||
        TipoCartaoEnum.AtividadesAvulsas === cartaoTipoId ||
        TipoCartaoEnum.HoraExtraTela === cartaoTipoId ||
        TipoCartaoEnum.HoraExtraImportacao === cartaoTipoId
    );
};

export const tenHourLimit = (cartaoTipoId: number): boolean => {
    return (
        TipoCartaoEnum.Antecipacao === cartaoTipoId ||
        TipoCartaoEnum.Substituicao === cartaoTipoId ||
        TipoCartaoEnum.Reposicao === cartaoTipoId
    );
};

export const isOvertimeCard = (
    card: any,
    type: TipoCartaoEnum = 0
): boolean => {
    const cardType = type || card.cartaoTipo?.cartaoTipoId;

    return (
        cardType === TipoCartaoEnum.HoraExtraTela ||
        cardType === TipoCartaoEnum.HoraExtraImportacao
    );
};
